import {
  Headset,
  Lock,
  Person,
  Settings,
  ShoppingCart
} from "@mui/icons-material";
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useState } from "react";
import { useUserStore } from "../../../stores";
import { colorPrimary, colorSubText } from "../../../theme";
import { AlterarSenhaTab } from "../components/AlterarSenha";
import { ConfiguracoesTab } from "../components/ConfiguracoresTab";
import { DadosLojistaTab } from "../components/DadosLojista";
import { MinhasComprasTab } from "../components/MinhasCompras";

type TabType = "compras" | "dados" | "seguranca" | "suporte" | "configuracoes";

export function PerfilBase() {
  const { user } = useUserStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  const [activeTab, setActiveTab] = useState<TabType>("compras");


  return (
    <Box
      display="flex"
      minHeight="100vh"
      bgcolor="#f8fafc"
      flexDirection={isTablet ? "column" : "row"}
    >
      {/* SIDEBAR */}
      {!isTablet && (
        <Box
          width={280}
          bgcolor="white"
          borderRight="1px solid #e2e8f0"
          position="sticky"
          top={0}
          height="55vh"
          overflow="auto"
          borderRadius={2}
        >
          {/* User Profile Section */}
          <Box
            p={3}
            borderBottom="1px solid #f1f5f9"
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Box
              width={80}
              height={80}
              bgcolor="#e2e8f0"
              borderRadius="50%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={2}
            >
              <Person sx={{ fontSize: 40, color: "#94a3b8" }} />
            </Box>
            <Typography fontWeight={700} fontSize="1rem" textAlign="center">
              {user?.nome ?? "--"}
            </Typography>
            <Typography
              fontSize="0.7rem"
              color={colorSubText}
              mb={0.5}
              textAlign="center"
            >
              {user?.email ?? "--"}
            </Typography>
            <Typography
              fontSize="0.65rem"
              fontWeight={600}
              color={colorSubText}
              textTransform="uppercase"
              letterSpacing={1}
            >
              Perfil: {user?.grupoAcesso.nome ?? "--"}
            </Typography>
          </Box>

          {/* Navigation Menu */}
          <Box p={1.5}>
            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              px={2}
              py={1.5}
              bgcolor={activeTab === "compras" ? colorPrimary : "transparent"}
              borderRadius={2}
              mb={0.5}
              onClick={() => setActiveTab("compras")}
              sx={{
                cursor: "pointer",
                color: activeTab === "compras" ? "white" : "#64748b",
                boxShadow: activeTab === "compras" ? "0 4px 12px rgba(255, 107, 0, 0.2)" : "none",
                "&:hover": {
                  bgcolor: activeTab === "compras" ? colorPrimary : "#f8fafc",
                },
                transition: "all 0.2s",
              }}
            >
              <ShoppingCart sx={{ fontSize: 20 }} />
              <Typography
                fontSize="0.875rem"
                fontWeight={activeTab === "compras" ? 700 : 500}
              >
                Minhas Compras
              </Typography>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              px={2}
              py={1.5}
              bgcolor={activeTab === "dados" ? colorPrimary : "transparent"}
              borderRadius={2}
              mb={0.5}
              onClick={() => setActiveTab("dados")}
              sx={{
                cursor: "pointer",
                color: activeTab === "dados" ? "white" : "#64748b",
                boxShadow: activeTab === "dados" ? "0 4px 12px rgba(255, 107, 0, 0.2)" : "none",
                "&:hover": {
                  bgcolor: activeTab === "dados" ? colorPrimary : "#f8fafc",
                },
                transition: "all 0.2s",
              }}
            >
              <Person sx={{ fontSize: 20 }} />
              <Typography
                fontSize="0.875rem"
                fontWeight={activeTab === "dados" ? 700 : 500}
              >
                Meus Dados
              </Typography>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              px={2}
              py={1.5}
              bgcolor={activeTab === "seguranca" ? colorPrimary : "transparent"}
              borderRadius={2}
              mb={0.5}
              onClick={() => setActiveTab("seguranca")}
              sx={{
                cursor: "pointer",
                color: activeTab === "seguranca" ? "white" : "#64748b",
                boxShadow: activeTab === "seguranca" ? "0 4px 12px rgba(255, 107, 0, 0.2)" : "none",
                "&:hover": {
                  bgcolor: activeTab === "seguranca" ? colorPrimary : "#f8fafc",
                },
                transition: "all 0.2s",
              }}
            >
              <Lock sx={{ fontSize: 20 }} />
              <Typography
                fontSize="0.875rem"
                fontWeight={activeTab === "seguranca" ? 700 : 500}
              >
                Segurança
              </Typography>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              px={2}
              py={1.5}
              bgcolor={activeTab === "suporte" ? colorPrimary : "transparent"}
              borderRadius={2}
              onClick={() => setActiveTab("suporte")}
              sx={{
                cursor: "pointer",
                color: activeTab === "suporte" ? "white" : "#64748b",
                boxShadow: activeTab === "suporte" ? "0 4px 12px rgba(255, 107, 0, 0.2)" : "none",
                "&:hover": {
                  bgcolor: activeTab === "suporte" ? colorPrimary : "#f8fafc",
                },
                transition: "all 0.2s",
              }}
            >
              <Headset sx={{ fontSize: 20 }} />
              <Typography
                fontSize="0.875rem"
                fontWeight={activeTab === "suporte" ? 700 : 500}
              >
                Suporte
              </Typography>
            </Box>
           
            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              px={2}
              py={1.5}
              bgcolor={activeTab === "configuracoes" ? colorPrimary : "transparent"}
              borderRadius={2}
              mb={0.5}
              onClick={() => setActiveTab("configuracoes")}
              sx={{
                cursor: "pointer",
                color: activeTab === "configuracoes" ? "white" : "#64748b",
                boxShadow: activeTab === "configuracoes" ? "0 4px 12px rgba(255, 107, 0, 0.2)" : "none",
                "&:hover": {
                  bgcolor: activeTab === "configuracoes" ? colorPrimary : "#f8fafc",
                },
                transition: "all 0.2s",
              }}
            >
              <Settings sx={{ fontSize: 20 }} />
              <Typography
                fontSize="0.875rem"
                fontWeight={activeTab === "configuracoes" ? 700 : 500}
              >
                Configurações
              </Typography>
            </Box>


          </Box>
        </Box>
      )}

      {/* MAIN CONTENT */}
      <Box flex={1} p={isMobile ? 2 : 5}>
        {activeTab === "compras" && <MinhasComprasTab />}
        {activeTab === "dados" && <DadosLojistaTab />}
        {activeTab === "seguranca" && <AlterarSenhaTab />}
        {activeTab === "suporte" && (
          <Box
            bgcolor="white"
            borderRadius={3}
            p={4}
            boxShadow="0 2px 8px rgba(0,0,0,0.05)"
          >
            <Typography variant="h6" fontWeight={700} mb={2}>
              Suporte
            </Typography>
            <Typography color={colorSubText}>
              Entre em contato através do email: canaldorepasse@gmail.com
            </Typography>
          </Box>
        )}
        {activeTab === "configuracoes" && <ConfiguracoesTab />}
      </Box>


    </Box>
  );
}
